import { render, staticRenderFns } from "./AlertsForms.vue?vue&type=template&id=3ffdd3d2&"
import script from "./AlertsForms.vue?vue&type=script&lang=js&"
export * from "./AlertsForms.vue?vue&type=script&lang=js&"
import style0 from "./AlertsForms.vue?vue&type=style&index=0&id=3ffdd3d2&prod&lang=css&"
import style1 from "./AlertsForms.vue?vue&type=style&index=1&id=3ffdd3d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports